@if (showNavbar) {
  <et-navbar class="print:hidden"></et-navbar>
}
<router-outlet></router-outlet>
